import React, { FC } from 'react';

import Box from '@material-ui/core/Box';
import { Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  page: {
    flex: 1,
    width: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'stretch',
      alignItems: 'stretch',
      alignSelf: 'stretch',
      padding: 0,
    },
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(2),
    },
  },
  card: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      maxWidth: '100%',
      borderRadius: 0,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 520,
      borderRadius: theme.shape.borderRadius,
    },
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      overflow: 'hidden',
      paddingBottom: theme.spacing(1),
      '&:last-child': {
        paddingBottom: theme.spacing(1),
      },
    },
  },
  scrollRegion: {
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
    },
  },
  footer: {
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 3, 3),
    },
  },
}));

export type OnGoLayoutProps = {
  /** Main body inside the card (typically wrapped in `scrollChildren` for mobile scroll). */
  children: React.ReactNode;
  /** Sticky action area below the card content (e.g. primary buttons). */
  footer: React.ReactNode;
  /** Optional wrapper around `children` for the scrollable column on small screens. */
  scrollChildren?: boolean;
  cardElevation?: number;
};

const OnGoLayout: FC<OnGoLayoutProps> = ({ children, footer, scrollChildren = true, cardElevation = 2 }) => {
  const classes = useStyles();

  const body = scrollChildren ? <div className={classes.scrollRegion}>{children}</div> : children;

  return (
    <div className={classes.page}>
      <Card className={classes.card} elevation={cardElevation}>
        <CardContent className={classes.cardContent}>{body}</CardContent>
        <Box className={classes.footer}>{footer}</Box>
      </Card>
    </div>
  );
};

export default OnGoLayout;
